import typeaheadMultiView from './typeaheadMultiComponent.html';
import './typeaheadMultiComponent.css';
import _ from 'lodash';
import { ensure } from 'components/sharpr/ensure/ensure';
import { regexQuote } from 'components/sharpr/regexQuote/regexQuote';

export function typeaheadMultiComponent() {
	return {
		bindings: {
			model: '=',
			items: '<?',
			provider: '<?',
			placeholder: '@?',
			minChars: '<?',
			maxItems: '<?',
			emptyVals: '<?',
			onChoose: '&?',
			onRemove: '&?',
			onChange: '&?',
			allowCustom: '<?',
			maxChoices: '<?',
		},
		controllerAs: 'vm',
		controller: typeaheadMultiComponentCtrl,
		template: typeaheadMultiView,
	};
}

export class typeaheadMultiComponentCtrl {
	constructor($element, $timeout, $scope) {
		'ngInject';
		this.$timeout = $timeout;
		let input = $element.find('input');
		let suggest = () => {
			this.autosize();
			this.generateSuggestions();
			$timeout(() => {});
		};
		let keypress = evt => {
			this.autosize();
			this.handleKeypress(evt);
			$timeout(() => {});
		};
		let blur = () => {
			// blur fires before click so we need to timeout
			// so that clicking on an item will choose it
			$timeout(() => {
				if (this.clickedItem) {
					this.clickedItem = false;
				} else {
					this.isFocused = false;
					this.suggestions = [];
				}
			}, 1000);
		};
		input.on('keyup', keypress);
		input.on('paste', suggest);
		input.on('delete', suggest);
		input.on('blur', blur);
		this.input = input[0];
		this.maxItems = typeof this.maxItems == 'number' ? this.maxItems : 10;
		this.minChars = this.minChars === undefined ? 2 : this.minChars;
		$scope.$watch('vm.isFocused', this.showEmptyVals.bind(this));
		//React to maxChoices changing
		$scope.$watch('vm.maxChoices', this.getMaxChosen.bind(this));
		this.autosize();
	}

	$onInit() {
		this.maxChosen = typeof this.maxChoices == 'number' ? this.maxChoices : Infinity;
	}

	getMaxChosen() {
		this.maxChosen = typeof this.maxChoices == 'number' ? this.maxChoices : Infinity;
	}

	handleKeypress(evt) {
		if (evt.which == 188) {
			// comma
			this.input.value = this.input.value.slice(0, this.input.value.length - 1);
			this.handleEnter();
		} else if (evt.which == 13) {
			this.handleEnter();
		} else if (evt.which == 8) {
			this.handleBackspace();
			this.generateSuggestions();
		} else if (evt.which == 38) {
			evt.preventDefault();
			this.navUp();
		} else if (evt.which == 40) {
			evt.preventDefault();
			this.navDown();
		} else {
			this.backspacedItem = null;
			this.generateSuggestions();
		}
	}

	focus() {
		this.input.focus();
		this.backspacedItem = null;
		this.isFocused = true;
	}

	clearInput() {
		this.input.value = '';
	}

	showEmptyVals(tryToShow) {
		if (!tryToShow) {
			return;
		}
		if (this.model.length == 0) {
			this.suggestions = this.emptyVals;
			return;
		}
		var chosen = _.pluck(this.model, 'name');
		if ((!this.suggestions || this.suggestions.length == 0) && this.emptyVals) {
			this.suggestions = this.emptyVals.filter(suggestion => {
				return chosen.indexOf(suggestion.name) == -1;
			});
		}
	}

	resetTypeahead() {
		this.clearInput();
		this.focus();
		this.autosize();
		this.suggestions = [];
		this.activeItem = null;
		this.showEmptyVals(true);
	}

	handleClick(item) {
		this.clickedItem = true;
		this.model.push(item);
		this.onChoose && this.onChoose({ $choice: item });
		this.onChange && this.onChange();
		this.resetTypeahead();
	}

	handleEnter() {
		if (this.activeItem) {
			this.model.push(this.activeItem);
			this.onChoose && this.onChoose({ $choice: this.activeItem });
			this.onChange && this.onChange();
			this.resetTypeahead();
			return;
		}
		let matcher = new RegExp('^' + regexQuote(this.input.value.trim()) + '$', 'i');
		let didFind =
			this.items &&
			this.items.some(item => {
				if (matcher.test(item.$search)) {
					this.model.push(item);
					this.onChoose && this.onChoose({ $choice: item });
					this.onChange && this.onChange();
					return true;
				}
			});
		if (!didFind) {
			if (!this.allowCustom) {
				// do nothing if this input doesn't allow custom entries
				return;
			}
			const newTagName = this.input.value.trim();
			const item = {
				$new: true,
				$label: newTagName,
				name: newTagName,
			};
			this.model.push(item);
			this.onChoose && this.onChoose({ $choice: item });
			this.onChange && this.onChange();
		}
		this.resetTypeahead();
	}

	handleBackspace() {
		if (this.input.selectionStart > 0 || this.input.selectionEnd > 0 || !this.model || this.model.length === 0) {
			this.autosize();
			return;
		}
		if (this.backspacedItem) {
			this.remove(this.backspacedItem);
			this.backspacedItem = null;
		} else {
			this.backspacedItem = this.model[this.model.length - 1];
		}
	}

	navUp() {
		const idx = this.suggestions.indexOf(this.activeItem);
		this.activeItem = idx >= 1 ? this.suggestions[idx - 1] : this.suggestions[this.suggestions.length - 1];
	}

	navDown() {
		const idx = this.suggestions.indexOf(this.activeItem);
		this.activeItem = idx > this.suggestions.length ? 0 : this.suggestions[idx + 1];
	}

	generateSuggestions() {
		if (this.input.value.length === 0) {
			this.showEmptyVals(true);
			return;
		}
		if (this.minChars > this.input.value.length) {
			this.suggestions = [];
			// not long enough of a query
			return;
		}
		// get suggestions
		// pluck out existing choices
		var chosen = _.pluck(this.model, '$search');
		// see if we should us a provider or static items
		if (_.isFunction(this.provider)) {
			// provider should return an array or a promise that returns an array
			ensure.promise(this.provider(this.input.value, chosen)).then(suggestions => {
				this.$timeout(() => {
					this.suggestions = ensure.array(suggestions).slice(0, this.maxItems || Infinity);
				});
			});
		} else if (_.isArray(this.items)) {
			this.suggestions = [];
			// search for suggestions within our static items
			let matcher = new RegExp(regexQuote(this.input.value), 'i');
			this.items.some(item => {
				if (matcher.test(item.$search) && chosen.indexOf(item.$search) == -1) {
					this.suggestions.push(item);
					if (this.suggestions.length > this.maxItems) {
						return true;
					}
				}
			});
		}
	}

	remove(item) {
		let idx = this.model.indexOf(item);
		if (idx > -1) {
			this.model.splice(idx, 1);
			this.onRemove && this.onRemove({ $choice: item });
			this.onChange && this.onChange();
		}
	}

	autosize() {
		this.input.style.width = 0;
		let neededWidth = this.input.scrollWidth + 9; // 9px minimum
		this.input.style.width = neededWidth + 'px';
	}

	isInputEmpty() {
		return this.input.value.length === 0;
	}
}
